import * as yup from 'yup';
import { EDOZVOLA_WEB_ID_REGEX, messages } from 'app/config/constants';

export const constructionLegalityDocumentAddFormSchema = yup.object().shape({
  webId: yup.string().matches(EDOZVOLA_WEB_ID_REGEX, 'Unesena šifra predmeta je neispravna!').required(messages.MANDATORY_FIELD),
  finalActDocumentName: yup.string().required(messages.MANDATORY_FIELD),
  classification: yup.string().required(messages.MANDATORY_FIELD),
  finalActFileNumber: yup.string().required(messages.MANDATORY_FIELD),
  finalDocumentAdmissionDate: yup.date().required(messages.MANDATORY_FIELD),
  solutionType: yup.string().required(messages.MANDATORY_FIELD),
  administrativeUnit: yup.string().required(messages.MANDATORY_FIELD),
  authority: yup.string().required(messages.MANDATORY_FIELD),
  executionDate: yup.date().required(messages.MANDATORY_FIELD),
  effectivenessDate: yup.date().notRequired()
});

export const  constructionLegalityFormValidationSchema = yup.object({
  plotConstructionAndProofOfLegality: yup.boolean(),
  existingBuildingRatio: yup.array().when('plotConstructionAndProofOfLegality', (keys, schema) =>
    keys[0] ? schema.min(1, messages.MANDATORY_FIELD).nonNullable(messages.MANDATORY_FIELD) : schema.notRequired(),
  ),
});
